class DomUtil {
  /**
   * Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
   * @param tagName
   * @param className
   * @param container
   * @returns {HTMLElement}
   */
  static create(tagName, className, container = null) {
    const el = document.createElement(tagName);
    el.className = className || "";
    if (container) {
      container.appendChild(el);
    }
    return el;
  }
  /**
   * Parses string to Dom
   * @param domStr
   * @param withWrapper
   * @param className
   * @returns {HTMLDivElement}
   */
  static parseDom(domStr, className) {
    const el = document.createElement("div");
    el.className = className || "";
    el.innerHTML = domStr;
    return el;
  }
}

class Widget {
  constructor(viewer, wrapper) {
    this._viewer = viewer;
    this._wrapper = wrapper;
    this._ready = false;
    this._enabled = false;
  }
  set enabled(enabled) {
    this._enabled = enabled;
    if (this._enableHook)
      this._enableHook();
  }
  get enabled() {
    return this._enabled;
  }
  get ready() {
    return this._ready;
  }
  /**
   * mount content
   */
  _mountContent() {
  }
  /**
   * binds event
   */
  _bindEvent() {
  }
  /**
   * Unbinds event
   */
  _unbindEvent() {
  }
  /**
   * When enable modifies the hook executed, the subclass copies it as required
   * @private
   */
  _enableHook() {
    if (!this._ready)
      this._mountContent();
    if (this._enabled) {
      if (!this._wrapper.parentNode)
        this._viewer.container.appendChild(this._wrapper);
      this._bindEvent();
    } else {
      this._unbindEvent();
      if (this._wrapper.parentNode)
        this._viewer.container.removeChild(this._wrapper);
    }
  }
  /**
   * Setting widget content
   * @param content
   * @returns {Widget}
   */
  setContent(content) {
    if (content && typeof content === "string") {
      this._wrapper.innerHTML = content;
    } else if (content && content instanceof Element) {
      while (this._wrapper.hasChildNodes()) {
        if (this._wrapper.firstChild)
          this._wrapper.removeChild(this._wrapper.firstChild);
      }
      this._wrapper.appendChild(content);
    }
    return this;
  }
  /**
   * hide widget
   */
  hide() {
    if (this._wrapper)
      this._wrapper.style.display = "none";
  }
  /**
   * show widget
   */
  show() {
    if (this._wrapper)
      this._wrapper.style.display = "block";
  }
  destroy() {
    this.enabled = false;
    this._ready = false;
  }
}

export { DomUtil, Widget };
